<div
  class="columns small-12 medium-6"
  data-masonry-item=""
  *ngIf="(internetProduct.clouds && internetProduct.clouds[0]) || internetProduct.mail"
>
  <div class="panel rs-bg-grey1">
    <h3 class="rs-tit6 rs-txt-c1 small-only-text-center" data-cy="internetAppsTitle">
      {{ 'internet.settings.internet.apps.title' | translate }}
    </h3>
    <div class="rs-flex-row rs-justify-center">
      <div class="rs-flex-columns" *ngIf="internetProduct.clouds && internetProduct.clouds[0]">
        <a
          href="javascript:void(0)"
          class="rs-block text-center rs-link-no-decoration rs-txt-c1 rs-txt-hover rs-txt-s3"
          (click)="redirectToCloud()"
          data-tms-event="link-click"
          data-tms-link-zone="internet options"
          attr.data-tms-link-name="{{ internetProduct.clouds[0].productDescription }}"
          data-tms-link-url="/cloud"
        >
          <img
            alt="{{ internetProduct.clouds[0].productDescription }}"
            class="rs-radius2 rs-h-s8 rs-margin-left2 rs-margin-right2 rs-margin-bottom1"
            src="{{ 'internet.settings.internet.apps.cloud.image.link' | translate }}"
          /><br />
          {{ internetProduct.clouds[0].productDescription }}
        </a>
      </div>

      <div class="rs-flex-columns" *ngIf="internetProduct.mail?.productDescription">
        <a
          href="javascript:void(0)"
          class="rs-block text-center rs-link-no-decoration rs-txt-c1 rs-txt-hover rs-txt-s3"
          (click)="openUrlOrApp(internetProduct.mail, pageRouter)"
          data-tms-event="link-click"
          data-tms-link-zone="internet options"
          attr.data-tms-link-name="{{ internetProduct.mail?.productDescription }}"
          data-tms-link-url="/details/mail"
          data-cy="linkToMail"
        >
          <img
            alt="{{ internetProduct.mail.productDescription }}"
            class="rs-radius2 rs-h-s8 rs-margin-left2 rs-margin-right2 rs-margin-bottom1"
            src="{{ 'internet.settings.internet.apps.my.mail.image.link' | translate }}"
          /><br />
          {{ internetProduct.mail.productDescription }}
        </a>
      </div>
    </div>
  </div>
</div>
